import { PayerAdjustmentGroupType } from '../../api/server/models/PayerAdjustmentGroupType';

export const PAYER_ADJUSTMENT_GROUP_TYPE_VALUES = Object.values(PayerAdjustmentGroupType);

const SHORT_CODE_BY_GROUP: Record<string, string> = {
    [PayerAdjustmentGroupType.CONTRACTUALOBLIGATIONS]: 'CO',
    [PayerAdjustmentGroupType.OTHERADJUSTMENTS]: 'OA',
    [PayerAdjustmentGroupType.PAYERINITIATEDREDUCTIONS]: 'PIR',
    [PayerAdjustmentGroupType.PATIENTRESPONSIBILITY]: 'PR',
    [PayerAdjustmentGroupType.CORRECTIONSANDREVERSALS]: 'CR',
};

const GROUP_BY_SHORT_CODE: Record<string, PayerAdjustmentGroupType> = {
    CO: PayerAdjustmentGroupType.CONTRACTUALOBLIGATIONS,
    OA: PayerAdjustmentGroupType.OTHERADJUSTMENTS,
    PI: PayerAdjustmentGroupType.PAYERINITIATEDREDUCTIONS,
    PIR: PayerAdjustmentGroupType.PAYERINITIATEDREDUCTIONS,
    PR: PayerAdjustmentGroupType.PATIENTRESPONSIBILITY,
    CR: PayerAdjustmentGroupType.CORRECTIONSANDREVERSALS,
};

export function isPayerAdjustmentGroupType(value: string): value is PayerAdjustmentGroupType {
    return (PAYER_ADJUSTMENT_GROUP_TYPE_VALUES as string[]).includes(value);
}

export function normalizePayerAdjustmentGroup(value: string): string {
    const trimmed = value.trim();
    if (!trimmed) {
        return trimmed;
    }

    const upper = trimmed.toUpperCase();
    if (isPayerAdjustmentGroupType(upper)) {
        return upper;
    }

    return GROUP_BY_SHORT_CODE[upper] ?? trimmed;
}

export function formatPayerAdjustmentGroupShortCode(value: string): string {
    const normalized = normalizePayerAdjustmentGroup(value);
    return SHORT_CODE_BY_GROUP[normalized] ?? value;
}

export function formatPayerAdjustmentGroupLabel(value: string): string {
    const normalized = normalizePayerAdjustmentGroup(value);

    return normalized
        .split('_')
        .filter(Boolean)
        .map(word => word.charAt(0) + word.slice(1).toLowerCase())
        .join(' ');
}
